<template>
  <div class="components-row">
    <label class="label">
      结束时间
      <el-tooltip
        content="选择自定义前请确认所选的试玩包支持自定义时间设置，若不支持时选中自定义会导致无法跳转结束页"
        placement="top"
      >
        <i class="el-icon-question"></i>
      </el-tooltip>
    </label>

    <div>
      <el-radio v-model="endTimeType" :label="WXGAME_PLAYABLE_PAGE_END_TIME.THIRTY_SECONDS">30s（推荐）</el-radio>
      <el-radio v-model="endTimeType" :label="WXGAME_PLAYABLE_PAGE_END_TIME.COMPLETE">自定义</el-radio>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { WXGAME_PLAYABLE_PAGE_END_TIME } from '@/views/create/gdt/model/creative-const.js'

// eslint-disable-next-line
const props = defineProps({
  value: String
})
// eslint-disable-next-line
const emits = defineEmits(['input'])

const endTimeType = computed({
  get: () => props.value,
  set: (value) => emits('input', value)
})
</script>

<style lang="scss" scoped>
.components-row {
  margin-bottom: 10px;
  display: flex;

  .label {
    padding-right: 10px;
    text-align: right;
    min-width: 130px;
    font-size: 14px;
  }
}
</style>
